// hooks/useAddSuccessorDoc.ts
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import axiosInstance from 'axiosConfig'
import { Toast } from 'shared'
import { TOAST_TYPES_ENUM } from 'enums'
import { queryClient } from 'App'
import { SESSION_QUERY_KEY } from './CheckSessionHook'

export type SuccessorDocType =
  | 'testament'
  | 'notarial_documents'
  | 'note'
  | 'deed_of_ownership'

export type AddSuccessorDocPayload = {
  type: SuccessorDocType
  name?: string | null
  description?: string | null
  isAccessibleByReliance: boolean | null
  file?: File | null
}

const ADD_SUCCESSOR_DOC_ENDPOINT = '/successors/add-document'

export const useAddSuccessorDoc = (
  options?: UseMutationOptions<any, Error, AddSuccessorDocPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ['addSuccessorDoc'],
    mutationFn: async (data: AddSuccessorDocPayload) => {
      const formData = new FormData()
      formData.append('type', data.type)
      if (data.name) formData.append('name', data.name)
      if (data.description) formData.append('description', data.description)

        if (data.isAccessibleByReliance === null) {
          formData.append('isAccessibleByReliance', 'null')
        } else {
          formData.append(
            'isAccessibleByReliance',
            String(Boolean(data.isAccessibleByReliance))
          )
        }
      if (data.file) formData.append('file', data.file)

      const res = await axiosInstance.post(ADD_SUCCESSOR_DOC_ENDPOINT, formData)
      return res.data
    },
    onMutate: (variables) => {
      Toast({
        id: 'add-successor-doc',
        type: TOAST_TYPES_ENUM.LOADING,
        message: 'Trwa dodawanie dokumentu…',
      })
      return options?.onMutate?.(variables)
    },
    onSuccess: (data, variables, context) => {
      const isVideo = !!(
        variables.file &&
        /\.(mp4|mov|3gp)$/i.test(variables.file.name)
      )
      Toast({
        id: 'add-successor-doc',
        type: TOAST_TYPES_ENUM.SUCCESS,
        message: isVideo
          ? 'Plik wgrany. Trwa kompresja wideo…'
          : 'Dokument dodany pomyślnie.',
      })
      queryClient.invalidateQueries({ queryKey: ['successors', 'docs'] })
      options?.onSuccess?.(data, variables, context)
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      
      const msg ='Błąd podczas dodawania dokumentu.'
      Toast({
        id: 'add-successor-doc',
        type: TOAST_TYPES_ENUM.ERROR,
        message: msg,
      })
      options?.onError?.(error, variables, context)
    },
  })
}

export default useAddSuccessorDoc
